import request from '@/utils/request'


// 查询短剧标签列表
export function listTag(query) {
  return request({
    url: '/video/faceMaterialTag/list',
    method: 'get',
    params: query
  })
}

// 查询短剧标签分页
export function pageTag(query) {
  return request({
    url: '/video/faceMaterialTag/page',
    method: 'get',
    params: query
  })
}
export function changeIsOpen(data) {
  return request({
    url: '/video/faceMaterialTag/changeIsOpen',
    method: 'post',
    data: data
  })
}
// 查询短剧标签详细
export function getTag(data) {
  return request({
    url: '/video/faceMaterialTag/detail',
    method: 'get',
    params: data
  })
}

// 新增短剧标签
export function addTag(data) {
  return request({
    url: '/video/faceMaterialTag/add',
    method: 'post',
    data: data
  })
}

// 修改短剧标签
export function updateTag(data) {
  return request({
    url: '/video/faceMaterialTag/edit',
    method: 'post',
    data: data
  })
}

// 删除短剧标签
export function delTag(data) {
  return request({
    url: '/video/faceMaterialTag/delete',
    method: 'post',
    data: data
  })
}
